import { useState } from 'react';
import { useIntervalWhen } from 'rooks';

const useCheckRemoteInitialized = ({ defer }: { defer: () => boolean }) => {
  const [ready, setReady] = useState(defer?.());
  useIntervalWhen(() => defer?.() && setReady(true), 1000, !ready);

  return { isRemoteInitialized: ready };
};

export default useCheckRemoteInitialized;
